import script from "./SafetyView.vue?vue&type=script&setup=true&lang=js"
export * from "./SafetyView.vue?vue&type=script&setup=true&lang=js"

import "./SafetyView.vue?vue&type=style&index=0&id=5fb5ab31&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fb5ab31"]])

export default __exports__